import { type ReactNode } from "react";
import { type ListBoxItemProps as ListBoxItemPrimitiveProps } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./ListBoxItem.styled";
import { Typography } from "../../Typography";

export type ListBoxItemProps = ListBoxItemPrimitiveProps & {
  icon?: ReactNode;
};

function ListBoxItem(props: ListBoxItemProps) {
  const { icon, children, ...otherProps } = props;

  const { tokens } = useDesignTokens();
  const { select } = tokens;

  return (
    <S.ListBoxItem {...otherProps}>
      {(renderProps) => {
        const { isSelected } = renderProps;

        return (
          <S.ContentWrapper>
            <S.Content $withIcon={icon !== undefined}>
              <S.TickIconWrapper>
                {isSelected && <S.TickIcon aria-hidden="true" />}
              </S.TickIconWrapper>

              {icon && <S.IconWrapper>{icon}</S.IconWrapper>}

              <Typography
                component="div"
                color="inherit"
                variant={select.menu.option.inner.text.typography.variant}
                fontFamily={select.menu.option.inner.text.typography.fontFamily}
              >
                {typeof children === "function"
                  ? children(renderProps)
                  : children}
              </Typography>
            </S.Content>
          </S.ContentWrapper>
        );
      }}
    </S.ListBoxItem>
  );
}

export default ListBoxItem;
